import * as React from "react";
import { Layout } from 'antd';
import '../Layout.less';
import 'src/pages/public/Public.less';
import GeneralHeader from "src/layouts/GeneralHeader";
const { Content } = Layout;

class CleanLayout extends React.Component<{}, {}> {
    render() {
        return <Layout className="clean">
            <GeneralHeader
                renderEmulationBanner={true}
                renderFullscreenToggle={true}
                renderLanguageToggle={true}
                renderAudioToggle={false}
                renderPlanetBox={false}
                renderBackToSpaceStation={true}
            />
            <Layout>
                <Content>
                    {this.props.children}
                </Content>
            </Layout>
        </Layout>;
    }
}

export default CleanLayout;



// WEBPACK FOOTER //
// ./src/layouts/clean/CleanLayout.tsx